export default __webpack_public_path__ + "static/media/gimp.e90f970a.svg";